import {getJson, postJson, deleteJson} from '@/util/ajaxUtils';

export function getFollows(externalUserId, extId) {
    return getJson(`/customer/list/follow/${externalUserId}/${extId}`);
}

export function getCustomerList(params) {
    return getJson('/customer/list', {params});
}

export function transfer(params) {
    return getJson('/customer/transfer', {params});
}

export function moments(params) {
    return getJson('/customer/moment/list', {params});
}

export function updateMomentTask(extId, momentId) {
    return getJson(`/customer/moment/update/${extId}/${momentId}`, {});
}

export function sendResult(params) {
    return getJson('/customer/moment/send/result', {params});
}

export function likesAndComments(params) {
    return getJson('/customer/moment/comments', {params});
}

export function getTasks(momentId) {
    return getJson(`/customer/moment/task/${momentId}`, {});
}

export function sendGroup(data) {
    return postJson('/customer/send/group', {data});
}

export function groupMessage(params) {
    return getJson('/customer/group/message', {params});
}

export function sendMsgResult(msgId, userId) {
    return getJson(`/customer/group/message/result/${msgId}/${userId}`, {});
}

export function groupMessageDetail(msgId, sendType, userId) {
    return getJson(`/customer/group/message/detail/${msgId}/${sendType}/${userId}`, {});
}

export function customerStatistic(params) {
    return getJson('/customer/statistic', {params});
}

export function groupStatistic(params) {
    return getJson('/customer/statistic/group', {params});
}

export function chartStatistic(params) {
    return getJson('customer/statistic/count/chart', {params});
}

export function countStatistic(extId) {
    return getJson(`/customer/statistic/count/${extId}`, {});
}

export function syncCustomer(extId) {
    return getJson(`/customer/sync/${extId}`, {});
}

export function getMediaId(data) {
    return postJson('/customer/moment/uploadAttachment', {data});
}

export function getWelcomeMediaId(data) {
    return postJson('/customer/welcome/uploadAttachment', {data});
}

export function getWelcomelist(extId) {
    return getJson(`/customer/welcome/list/${extId}`, {});
}

export function getWelcomeAttachList(configId) {
    return getJson(`/customer/welcome/list/attach/${configId}`, {});
}

export function delWelcomeConfig(configId) {
    return deleteJson(`/customer/welcome/del/${configId}`, {});
}

export function addCustomerWelcomeConfig(data) {
    return postJson('/customer/welcome/config/add', {data});
}

export function addRoomWelcomeConfig(data) {
    return postJson('/customer/welcome/room/config/add', {data});
}

export function updateCustomerWelcomeConfig(data) {
    return postJson('/customer/welcome/config/update', {data});
}

export function addMomentTask(data) {
    return postJson('/customer/moment/addMomentTask', {data});
}

export function getAllGroups(searchValue) {
    return getJson(`/customer/corptag/getAllGroups`, {params: {s: searchValue}});
}

export function addCorpTag(params) {
    return postJson('/customer/corptag/add', {data: params});
}

export function updateCorpTag(params) {
    return postJson(`/customer/corptag/edit`, {data: params});
}

export function deleteCorpTag(params) {
    return postJson(`/customer/corptag/delete`, {data: params});
}

export function getTags(params) {
    return getJson('/customer/corptag/list', {params});
}

export function saveCustomerTagLink(params) {
    return postJson('/customer/taglink/save', {data: params});
}

export function listCustomerTagLink(id) {
    return getJson(`/customer/taglink/${id}`, {});
}

export function syncCorpTag(params) {
    return postJson(`/customer/corptag/sync`, {data: params});
}

export function deconsent(params) {
    return getJson(`/customer/deConsent`, {params});
}

export function consentList(params) {
    return getJson(`/customer/consent/list`, {params});
}
